import { API_URLS } from "../../../Configs/apiUrls";
import axiosInstance from "../../../Configs/axios";

export const PostNotifyMeData = (req) => {
    try {
        const response = axiosInstance.post(API_URLS.notify_me, req)
        return response
    }
    catch (e) {
        throw new Error(e);
    }
}